import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { StsTenantService } from './services/sts-tenant.service';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  title = 'Login';
  background = '';
  showHeaderBanner = false;
  showHeaderNormal = false;
  isIE11 = false;

  favicons = [
    { id: 'apple-icon-57x57', rel: 'apple-touch-icon', sizes: '57x57', ref: 'favicons/apple-icon-57x57.png?v=1' },
    { id: 'apple-icon-60x60', rel: 'apple-touch-icon', sizes: '60x60', ref: 'favicons/apple-icon-60x60.png?v=1' },
    { id: 'apple-icon-72x72', rel: 'apple-touch-icon', sizes: '72x72', ref: 'favicons/apple-icon-72x72.png?v=1' },
    { id: 'apple-icon-76x76', rel: 'apple-touch-icon', sizes: '76x76', ref: 'favicons/apple-icon-76x76.png?v=1' },
    { id: 'apple-icon-114x114', rel: 'apple-touch-icon', sizes: '114x114', ref: 'favicons/apple-icon-114x114.png?v=1' },
    { id: 'apple-icon-120x120', rel: 'apple-touch-icon', sizes: '120x120', ref: 'favicons/apple-icon-120x120.png?v=1' },
    { id: 'apple-icon-144x144', rel: 'apple-touch-icon', sizes: '144x144', ref: 'favicons/apple-icon-144x144.png?v=1' },
    { id: 'apple-icon-152x152', rel: 'apple-touch-icon', sizes: '152x152', ref: 'favicons/apple-icon-152x152.png?v=1' },
    { id: 'apple-icon-180x180', rel: 'apple-touch-icon', sizes: '180x180', ref: 'favicons/apple-icon-180x180.png?v=1' },
    { id: 'android-icon-192x192', rel: 'icon', type: 'image/png', sizes: '192x192', ref: 'favicons/android-icon-192x192.png?v=1' },
    { id: 'favicon-32x32', rel: 'icon', type: 'image/png', sizes: '32x32', ref: 'favicons/favicon-32x32.png?v=1' },
    { id: 'favicon-96x96', rel: 'icon', type: 'image/png', sizes: '96x96', ref: 'favicons/favicon-96x96.png?v=1' },
    { id: 'favicon-16x16', rel: 'icon', type: 'image/png', sizes: '16x16', ref: 'favicons/favicon-16x16.png?v=1' }
  ];

  public constructor(private router: Router,
                      private titleService: Title,
                     private tenantService: StsTenantService,
                     @Inject(DOCUMENT) private document) {
    this.isIE11 = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;

    this.tenantService.getConfigSource().subscribe(
      res => {
        this.background = `url('${res.loginBackgroundImage}')`;
        this.titleService.setTitle(res.siteName);
      });
    this.tenantService.getTenantSource().subscribe(
      res => {
        /* Set favicon attributes
           HTML for these favicons is on
           ...Repos\client-dedicated-projects\ARIELHARMONYMEMBER2\WEBSITES\WP\WP_CONTENT
            \ViewsDedicated\ARIELHARMONYMEMBER2\Account\MustAuthLogin.cshtml
        */
        for (let i in this.favicons) {
          let iconLink = this.document.getElementById(this.favicons[i].id);
          iconLink.setAttribute('href', `/tools/ariel-sts-app/${res.code}/app/assets/images/${this.favicons[i].ref}`);
          iconLink.setAttribute('rel', this.favicons[i].rel);
          iconLink.setAttribute('sizes', this.favicons[i].sizes);
        }

        this.showHeaderBanner = res.showHeaderBanner ;
        this.showHeaderNormal = res.showHeaderNormal == null || res.showHeaderNormal === true;
        if (res.currentLocale) {
          this.document.documentElement.lang = res.currentLocale;
        }
      });
  }
  
  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
            const mainHeader = document.getElementById('main-app-content');
            if (mainHeader) {
              mainHeader.focus();
            }
      }
    })
  }
}
